// extracted by mini-css-extract-plugin
export default {"main":"Forbidden_main__8Khge"};